(function($) {
const toggleAffix = (affixElement, scrollElement, wrapper) => {
  const height = affixElement.outerHeight(),
    top = wrapper.offset().top;

  if (scrollElement.scrollTop() >= top) {
    wrapper.height(height);
    affixElement.addClass("affix");
  } else {
    affixElement.removeClass("affix");
    wrapper.height("auto");
  }
};


const toggleActiveRow = (el) => {
  
  let appNumber = el.children('.cell--appartmentName').html();
  let appRooms  = el.children('.cell--rooms').html();
  let appArea   = el.children('.cell--area').html();
  let appTerrace= el.children('.cell--terrace').html();
  let appPrice  = el.children('.cell--price').html();
  let appLink   = el.find('a').attr('href');
  let appImg    = el.data('img');

  $('.table__row.d-none').removeClass('d-none');
  el.addClass('d-none');

  
  if(appTerrace.length) {
    appArea += ' + Terrasse '+ appTerrace + '&nbsp;m<sup>2<sup>';
  }

  if($('.table__row.active').length){
    $('.table__row.active').remove();
  }

  el.after(function(){
    return '<tr class="table__row active"><td colspan="5"><div class="data__container d-flex"><h3 class="cell--appartmentName">'+ appNumber +'</h3><div class="left"><ul><li class="cell-rooms">'+ appRooms +'</li><li class="cell--area">Surface '+ appArea +'</li><li class="cell--price">'+ appPrice +'</li></ul><a class="cell--link btn btn-sm btn-secondary" href="'+ appLink +'">Voir l’appartement</a><a class="cell--link btn btn-sm btn-anchor" href="#simulator">Localiser sur le projet</a></div></div></td></tr>';
  });
  
  $('#appartement__image').css('background-image', 'url('+appImg+')');

}

function filterForm(form){

  // var rooms = [];
  // var prices = [];
  let typeCategory = '';
  let types = [];

  // if(typeof form.find("[name='building']:checked").val() !== 'undefined') {
  //   var buildingEl = form.find("[name='building']:checked");
  //   var building = buildingEl.val();
    
  //   // Edit Building image
  //   var buildingImg = buildingEl.data('img');    
  //   $('.building__image').css('background-image', 'url('+buildingImg+')');

    
  //   // on cache les étages non-disponibles pour ce batiment
  //   var appMaxFloor    = buildingEl.data('maxfloor');
  //   $("input[name='floors']").each(function() {
  //     var value = $(this).attr('value');

  //     if(parseInt(value) > parseInt(appMaxFloor)) {
  //       $(this).parent().hide();
  //     } else {
  //       $(this).parent().show();
  //     }
  //   })
    
   
  // }

  if(typeof form.find("[name='floors']:checked").val() !== 'undefined') {
    var floors = form.find("[name='floors']:checked").val();
  }

  // if(typeof form.find("[name='rooms']:checked").val() !== 'undefined') {
  //   rooms = [];
  //   $("input[name='rooms']:checked").each( function(){            
  //     rooms.push($(this).val());
  //   });
  // }

  if(typeof form.find("[name='type']:checked").val() !== 'undefined') {
    $("input[name='type']:checked").each(function(){
      typeCategory = $(this).data('type');
      if( typeCategory === 'rooms' ) {
        types.push($(this).data('rooms'));
      } else {
        types.push($(this).data('minprice'));
        types.push($(this).data('maxprice'));
      }      
    });
  }

  // console.log("building :" + building);
  // console.log("floor :" + floors);
  // console.log("type :" + type);

  var rows = $('.table__row');
  // console.log(rows);

  rows.each(function(){
    
    var el = $(this);

    if(el.hasClass('active')){
      return true;
    }

    // var rowBuilding = el.data('building');
    var rowRooms = el.data('rooms');
    // var rowType = el.data('type');
    var rowFloor = el.data('floors').toString();
    rowFloor = rowFloor.split(',').map( Number );
    // console.log({floors, rowFloor});
    var rowPrice = el.data('price');

    var filters = [];
    
    // if(rooms.includes(rowRooms.toString()) || rooms.length === 0){
    //   filters.push(1);
    // } else {
    //   filters.push(0);
    // }
    if(types.length !== 0) {
      
      if(typeCategory === 'rooms' ) {
        if (types.includes(rowRooms) || types.includes('all')){
          filters.push(1);
        } else {
          filters.push(0);
        }
      } else if (typeCategory === 'price') {
        const minPrice = Math.min(...types);
        const maxPrice = Math.max(...types);
        if(minPrice <= rowPrice && rowPrice <= maxPrice) {
          filters.push(1);
        } else {
          filters.push(0);
        }
      }

    } else {
      filters.push(1);
    }

    // if(rowBuilding == building || building === 'all'){
    //   filters.push(1);
    // } else {
    //   filters.push(0);
    // }
    // console.log(rowFloor.includes(parseInt(floors)));
    if(rowFloor.includes(parseInt(floors)) || floors === 'all'){
      filters.push(1);
    } else {
      filters.push(0);
    }

    // console.log(filters);

    if(filters.includes(0)){
      el.hide();
    } else {
      el.show();
    }
  });

  
  // var first = $('tbody').children('.table__row:visible:not(.active):first');
  $('.table__row.d-none').removeClass('d-none');
  if($('.table__row.active').length){
    $('.table__row.active').remove();
  }
  // var first = $('tbody').children('.table__row:visible:first');
  // if(first.length !== 0){
  //   toggleActiveRow(first);
  // }
}



$(function() {
  
  

  $('[href^="tel:"]').on('click', function(){
    dataLayer.push({'event':'event-clic-tel'});
  });

  // document.addEventListener( 'wpcf7mailsent', function( event ) {
  //   if ( 5 == event.detail.contactFormId ) {
  //       dataLayer.push({'event':'event-form-contact-envoye'});
  //   }
  // }, false );

  var floatlabels = new FloatLabels( 'form', {
    // options go here
  });
  
  $("#price-range").ionRangeSlider({
    type: "double",
    min: 80000,
    max: 600000,
    from: 100000,
    to: 300000,
    step: 5000,
    hide_min_max: true,
    grid: true,
    postfix: "€"
  });
  
  $("#price-range").on('change', function () {
    var $inp = $(this);
    var from = $inp.data("from");   // input data-from attribute
    var to = $inp.data("to");       // input data-to attribute
    var value = from+','+to;
    $inp.val(value)
    var v = $inp.val();     // input value in format FROM;TO
  
    // console.log(v, from, to);       // all values
  });

  $("#hero__image_toogle").on("click", function(e) {
    var toggleTitleObject = $(this).children(".image_toggle__title");
    var toggleImageObject = $(this).children(".image_toggle__image");
    var toggleTitleContent = toggleTitleObject.data("night");
    var toggleImgContent = toggleImageObject.data("night");

    if ($("#hero").hasClass("hero__image--day")) {
      toggleTitleContent = toggleTitleObject.data("day");
      toggleImgContent = toggleImageObject.data("day");
    }

    toggleTitleObject.html(toggleTitleContent);
    toggleImageObject.attr("src", toggleImgContent);
    $("#hero").toggleClass("hero__image--day");
  });

  /*
   * Fixed menu
   */

  // use toggleAffix on any data-toggle="affix" elements
  // $('[data-toggle="affix"]').each(function() {
  //   var ele = $(this),
  //     wrapper = $("<div></div>");

  //   ele.before(wrapper);
  //   $(window).on("scroll resize", function() {
  //     toggleAffix(ele, $(this), wrapper);
  //   });

  //   // init
  //   toggleAffix(ele, $(window), wrapper);
  // });

  // $(window).on('scroll', function() {
  //   /* affix after scrolling 100px */
  //   if ($(document).scrollTop() > 100 && !(jQuery('body').hasClass('post-type-archive')) ) {
  //     $(".header").addClass("fixed-top affix");
  //   } else {
  //     $(".header").removeClass("fixed-top affix");
  //   }
  // });

  $(".header").removeClass("fixed-top affix");

  /**
   * Animated scroll
   */
  $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .on('click', function(event) {
      // On-page links
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $("html, body").animate(
            {
              scrollTop: target.offset().top
            },
            1000,
            function() {
              // Callback after animation
              // Must change focus!
              var $target = $(target);
              $target.focus();
              if ($target.is(":focus")) {
                // Checking if the target was focused
                return false;
              } else {
                $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
              }
            }
          );
        }
      }
    });

  /**
   * Responsive menu animations
   */

  // when opening the responsive menu
  $("#sidebarCollapse").on("click", function() {
    // open responsive menu
    $(".navbar--mobile").toggleClass("active");
    $("a[aria-expanded=true]").attr("aria-expanded", "false");
    $(this).toggleClass("active");
  });

  let observer = new MutationObserver( mutations => {
    mutations.forEach( mutation => {
      if (mutation.type === "attributes") {
        
        let header = document.getElementById("header");
        let dropdown = mutation.target.nextElementSibling;
        const offset = mutation.target.getBoundingClientRect();
        const top = offset.top;
        const elementHeight = mutation.target.clientHeight;
        let dropdownHeight = dropdown.clientHeight;
        const navHeight = Math.ceil(top + elementHeight + dropdownHeight);
        
        document.documentElement.style.setProperty('--nav-height', navHeight + 24 + 'px'); 
        header.classList.toggle('header--open')
      }
      
      // console.log(mutation.target);
    });
  });
  
  document.querySelectorAll('.dropdown-toggle').forEach(element => {
    // observer.observe(element, {
    //   attributes: true //configure it to listen to attribute changes
    // });
    let header = document.getElementById("header");
    element.addEventListener('mouseover', event => {
      let dropdown = event.target.nextElementSibling;
      const offset = event.target.getBoundingClientRect();
      const top = offset.top;
      const elementHeight = event.target.clientHeight;
      let dropdownHeight = dropdown.clientHeight;
      const navHeight = Math.ceil(top + elementHeight + dropdownHeight);
      
      document.documentElement.style.setProperty('--nav-height', navHeight + 24 + 'px'); 
      header.classList.toggle('header--open')
    });
    element.addEventListener('mouseout', event => {
      header.classList.toggle('header--open')
    })
  });
  document.querySelectorAll('.dropdown-menu').forEach(element => {
    // observer.observe(element, {
    //   attributes: true //configure it to listen to attribute changes
    // });
    let header = document.getElementById("header");
    element.addEventListener('mouseover', event => {
      let dropdown = event.target.nextElementSibling;

      if (!(dropdown instanceof Node)) {
        return
      }

      const offset = event.target.getBoundingClientRect();
      const top = offset.top;
      const elementHeight = event.target.clientHeight;
      let dropdownHeight = dropdown.clientHeight;
      const navHeight = Math.ceil(top + elementHeight + dropdownHeight);
      
      document.documentElement.style.setProperty('--nav-height', navHeight + 24 + 'px'); 
      header.classList.toggle('header--open')
    });
    // element.addEventListener('mouseout', event => {
    //   header.classList.toggle('header--open')
    // })
  });

  $(".overlay").on("click", function() {
    // hide the menu
    $(".navbar.responsive").removeClass("active");
    $(".dropdown-menu").removeClass("active");
    // fade out the overlay
    $(".overlay").fadeOut();
  });

  $('th a').on('click', function (e){
    e.preventDefault();
    var el = $(this);

    el.parent().siblings().find('a').removeClass('asc desc');

    el.toggleClass(function() {
      if($(this).hasClass('asc')){
        return 'desc';
      } else {
        return 'asc';
      }
    });

  });

  
  var table = document.getElementById('appartmentTable');
  if(table !== null){
    
    new Tablesort(table);

    table.addEventListener('beforeSort', function() {
      if($('.table__row.active').length){
        $('.table__row.active').remove();
      }
    });

    // table.addEventListener('afterSort', function() {
    //   var active = $('tbody').children('.table__row.d-none');
    //     if(active.length !== 0){
    //       toggleActiveRow(active);
    //     }
    // });
  }


  $('.gallery__list').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    adaptiveHeight: false,
    asNavFor: '.gallery__nav',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          adaptiveHeight: true,
        }
      },
    ]
  });

  $('.gallery__nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '.gallery__list',
    focusOnSelect: true,
    vertical: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          vertical: false,
        }
      },
    ]
  });

  // $('.table__row').on('click', function(e){
  //   e.preventDefault();
    
  //   toggleActiveRow($(this));
    
  // });

  var form = $('#filter-form');
  form.find('.filter__input').on( 'change', function(){
    filterForm(form);
  });

  // var first = $('tbody').children('.table__row:visible:first');
  // if(first.length !== 0){
  //   toggleActiveRow(first);
  // }

  // Add select for mobile version
  // $('<label class="appartment__select-label" for="buildingSelect">Bâtiment</label><select id="buildingSelect" for="building" class="appartment__select" />').appendTo(".appartments__filters");
  $('<label class="appartment__select-label" for="floorSelect">Étage</label><select id="floorSelect" for="floors" class="appartment__select" />').appendTo(".appartments__filters");
  $('<label class="appartment__select-label" for="typeSelect">Nombre de chambres</label><select id="typeSelect" for="type" class="appartment__select" multiple/>').appendTo(".appartments__filters");

  // Create default option "
  // $("<option />", {
  //   "selected": "selected",
  //   "default" : "default",
  //   "value"   : "",
  //   "text"    : 'Bâtiment'
  // }).appendTo(".appartments__filters select[for='building']");

  // $("<option />", {
  //   "selected": "selected",
  //   "default" : "default",
  //   "value"   : "",
  //   "text"    : 'Étage'
  // }).appendTo(".appartments__filters select[for='floors']");

  // Populate select with buttons
  $(".appartments__filters .filter__group").each(function() {
    var el = $(this);
    var name = $('input',el).attr('name');
    if ($('input', el).attr("value") != '-3' && $('input', el).attr("value") != '-2' && $('input', el).attr("value") != '5' ) {
      $("<option />", {
          "value"   : $('input', el).attr("value"),
          "text"    : $('label', el).text()
      }).appendTo(".appartments__filters select[for='"+name+"']");
    }

  });

  // Edit main input on select change
  $(".appartment__select").on('change', function() {
    var values = [];
    $('option', this).each(function() {
      if($(this).is(':selected')) {
        // console.log("VALUE : " + $(this).val());
        values.push($(this).val()); 
      }
    })
   
    // Reset des filtres si multiselect
    var selectedValueName = $(this).attr('for');
    if($(this).attr('multiple')) {
      $('.appartments__filters input[name="'+selectedValueName+'"]').prop("checked", false);
    }

    // console.log("Value : " + values)
    // console.log("For : " + selectedValueName)

    for(var i=0 ; i<values.length ; i++) {
      var selectValue = values[i]
      // console.log(selectValue)
      $('.appartments__filters input[value="'+selectValue+'"][name="'+selectedValueName+'"]').prop("checked", true);
    }

    filterForm(form);
  })

  $('.appartment__select').selectpicker({
    'noneSelectedText' : 'Nombre de chambres'
  });

  // Edit select on input change
  $('#filter-form .filter__input').each(function(){
    if($(this).prop('checked')) {
      var id = $(this).attr('id');
      var value = $(this).val();
      var name = $(this).attr("name");
      var label = $('label[for="'+id+'"]').text()

      //Get the text using the value of select
      var el = $(".appartments__filters select[for='"+name+"']").parent();

      var text = $("select[for='"+name+"'][value='"+value+"']").text();
      
      //We need to show the text inside the span that the plugin show
      $('.filter-option-inner-inner', el).text(label);
      //Check the selected attribute for the real select
      $('select', el).val(value);

      $(".appartments__filters select[for='"+name+"'][value='"+value+"']").click();
    }
    
  });

  filterForm(form);
  // cloneMenu(".navbar-nav");

  function displayFloorModal(selector) {
    let element = selector[0];
    const id = element.id;
    let modal = document.querySelector('.' + id);
    if (modal) {
      modal.classList.toggle('show');
      if (modal.classList.contains('show')) {
        element.classList.add('show')
      } else {
        element.classList.remove('show')
      }
    }
  }

  $('.home .simulator__svg .floor, .floor_preview').hover(function() {
    displayFloorModal($(this));
  })

  // $('.floor_preview').hover(function() {
  //   displayFloorModal($(this));
  // })

  var Slider = {

    builderSlider: () => {
      let slider = document.querySelector('.skills__slider');
      if( ! slider ) {
        return;
      }
      let splide = new Splide( slider, {
        type: 'slide',
        arrows: false,
        pagination: false,
        autoWidth: 1,
        gap: '1rem',
        wheel       : true,
        releaseWheel: true,
      });
      let bar    = splide.root.querySelector( '.skills__slider-progress-bar' );
      // Update the bar width:
      splide.on( 'mounted move', function () {
        let viewWidth = splide.Components.Layout.listSize();
        let itemWidth = splide.Components.Layout.slideSize();
        var totalSlides = splide.Components.Controller.getEnd() + 1;
        let slidesInView = viewWidth / itemWidth;
        let index = splide.index <= (totalSlides - slidesInView) ? splide.index : (totalSlides - slidesInView);
        
        // console.log(index / totalSlides)
        if(slidesInView < totalSlides) {
          bar.parentNode.classList.remove('d-none');
          bar.style.width = String( 100 * (slidesInView / totalSlides) ) + '%';
          bar.style.transform = 'translateX(' + String( index / totalSlides * viewWidth) + 'px)';
        } else {
          bar.parentNode.classList.add('d-none');
        }
      } );
      splide.mount();
    }
  }

  Slider.builderSlider();

  let appartmentLinks = document.querySelectorAll('.appartment__link--js');
  appartmentLinks.forEach( element => {
    element.addEventListener('click', event => {
      event.preventDefault();
      const link = element.getAttribute('href');
      fetch(link)
        .then(response => {
          return response.text()
        })
        .then(html => {
          let parser = new DOMParser();
          let doc = parser.parseFromString(html, "text/html");
  
          let docAppartment = doc.querySelector('main').outerHTML;
  
          let instance = lity(docAppartment);
          let content = instance.content();
          //displayForm(content[0].querySelector('#simulate-ttc'));

          content.find('.gallery__list').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            adaptiveHeight: false,
            asNavFor: '.gallery__nav',
            responsive: [
              {
                breakpoint: 991,
                settings: {
                  adaptiveHeight: true,
                }
              },
            ]
          });

          content.find('.gallery__nav').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
            asNavFor: '.gallery__list',
            focusOnSelect: true,
            vertical: true,
            infinite: false,
            responsive: [
              {
                breakpoint: 991,
                settings: {
                  vertical: false,
                }
              },
            ]
          });
        })
    })
  })

});


const initialize = () => {
  const svg = document.querySelector('.simulator__svg');

  const sideSelector = (id) => {
    let element = document.getElementById(id);
    if(element) {
      element.addEventListener('click', event => {
        const elementClasses = element.classList;
        const svgSides = svg.querySelectorAll('.side');
        elementClasses.toggle('side-selector--front');
        elementClasses.toggle('side-selector--rear');
        svgSides.forEach( element => {
          element.classList.toggle('active');
        });
      });
    }
  };

  const floorSelector = (classname) => {
    let floors = document.querySelectorAll(classname);
    if(floors.length) {
      floors.forEach( element => {
        element.addEventListener('click', event => {
          event.preventDefault();

          // Hide side selector
          const sideSelector = document.getElementById('side-selector');
          if(sideSelector) {
            sideSelector.style.display = 'none';
          }

          // reset active class on siblings
          floors.forEach(element => {
            element.classList.remove('active');
          })

          // Get floor value & find related group in svg
          const floor = element.getAttribute('data-floor');
          let targetSVG = svg.getElementById('simulator-'+floor);

          // Add active class on dedicated elements
          element.classList.add('active');
          targetSVG.classList.add('show');
          setTimeout(() => {
            targetSVG.classList.add('active')
            targetSVG.classList.remove('show');
          }, '500');

          // Reset active class on svg group's siblings
          for (let sibling of targetSVG.parentNode.children) {
            if (sibling.classList.contains('active')) {
              sibling.classList.add('hide');
              sibling.classList.remove('active')
              setTimeout(() => {
                sibling.classList.remove('hide');
              }, '750');
            }
          }

          // Find input for floors in filter form & check it
          let form = jQuery('#filter-form');
          let filter = document.getElementById('etage_'+floor);
          filter.checked = true;
          filterForm(form);

        })
      })
    }
  };

  const isHeaderSticky = (selector) => {
    const el = document.querySelector(selector)
    const observer = new IntersectionObserver(([e]) => {
      e.target.classList.toggle("is-pinned", e.intersectionRatio < 1)},{ threshold: [0, 1] }
    );

    observer.observe(el);
  }

  isHeaderSticky('#header');
  sideSelector('side-selector');
  floorSelector('.floor__link');
}

function addListener(fn) {
    box.addEventListener('transitionend', fn);
  }

  function removeListener(fn) {
    box.removeEventListener('transitionend', fn);
  }

if (document.readyState == 'loading') {
  // still loading, wait for the event
  document.addEventListener('DOMContentLoaded', initialize);
} else {
  // DOM is ready!
  initialize();
}
})(jQuery);


const initializeSimulator = () => {
  const buttonID = '#simulate-ttc';

  let button = document.querySelector(buttonID);
  let parking = document.getElementById('simulator-parking');
  if (document.readyState == 'loading') {
    // still loading, wait for the event
    document.addEventListener('DOMContentLoaded', () => {
      displayForm(button);
      getFieldAttribute(parking, 'rooms');
    });
  } else {
    // DOM is ready!
    displayForm(button);
    getFieldAttribute(parking, 'rooms');
  }
}

const addFetchEvent = (form, results) => {

  if(form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      let button = this.querySelector('[type="submit"]');
      let data = this;
      displayLoading(button);

      fetch(ajax.url, {
        method: data.getAttribute('method'),
        credentials: 'same-origin',
        body: new FormData(data)
      })
      .then((response) => response.json())
      .then((data) => {
        setTimeout(() => {
          // let results = ovelay.getElementById('price-results');
          hideLoading(button);
          // console.log(data);
          // let container = form.parentElement;

          let appartementPrefix = results.querySelector('#appartement-prefix');
          let appartement = results.querySelector('#appartement');
          let frais = results.querySelector('#frais');
          let terrain = results.querySelector('#terrain');
          let construction = results.querySelector('#construction');
          let taxes = results.querySelector('#taxes');
          let total = results.querySelector('#total');

          appartementPrefix.innerHTML = data.prefix;
          appartement.innerHTML = data.appartement;
          frais.innerHTML = data.raccordements + '&nbsp;€';
          terrain.innerHTML = data.terrain + '&nbsp;€';
          construction.innerHTML = data.construction + '&nbsp;€';
          taxes.innerHTML = data.taxes + '&nbsp;€';
          total.innerHTML = '<strong>' + data.total + '&nbsp;€</strong>';

          form.classList.add('hide');
          results.classList.add('show');
        }, 1000);
      })
      .catch((error) => console.error(error))
    })
  }
}

const displayLoading = element => {
  element.classList.add("loading");
  // to stop loading after some time
  setTimeout(() => {
    element.classList.remove("loading");


  }, 5000);
}

// hiding loading
const hideLoading = element =>  {
  element.classList.remove("loading");
}

const displayForm = (button) => {
  // let button = document.querySelector(buttonID);
  let overlay = document.querySelector('.overlay--simulator');
  if(button) {
    button.addEventListener('click', function (event) {
      let instance = lity(overlay.outerHTML);
      let content = instance.content();
      let form = content[0].querySelector('.price-simulator');
      let results = content[0].querySelector('#price-results');
      addFetchEvent(form, results);
    });
  } else {
    let form = document.getElementById('price-simulator');
    let results = document.getElementById('price-results');
    if(form && results) {
      addFetchEvent(form, results);
    }
  }
}

const getFieldAttribute = (element, attribute) => {
  const select = document.querySelector('.price-simulator__appartment');
  // console.log({select});

  if(select !== null && element !== null) {
    toggleField(select, element, attribute)

    select.addEventListener('change', event => {
      toggleField(event.target, element, attribute)
    })
  }
}

const toggleField = (select, element, attribute) => {
  let selectedOptions = select.selectedOptions;
  let dataset = {...selectedOptions[0].dataset};
  let inputsRequired

  if(dataset[attribute] == '0') {
    element.classList.add('d-none');
    inputsRequired = element.querySelectorAll(`input[required]`)
  } else {
    element.classList.remove('d-none');
    inputsRequired = element.querySelectorAll(`input[data-should-required]`)
  }

  /**
   * Manage "required" attribute
   */
  if (inputsRequired.length > 0) {
    inputsRequired.forEach(inputRequired => {
      if (dataset[attribute] == '0' && inputRequired.hasAttribute(`required`)) {
        inputRequired.removeAttribute(`required`)
        inputRequired.setAttribute(`data-should-required`, ``)
        inputRequired.checked = false
      } else if (inputRequired.hasAttribute(`data-should-required`)) {
        inputRequired.setAttribute(`required`, ``)
        inputRequired.removeAttribute(`data-should-required`)
      }
    })
  }
}

initializeSimulator();